import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useMappingStore from '../stores/useMappingStore';
import useMappingUiStore from '../stores/useMappingUiStore';

export function useMappingBootstrap({ project_id, mapping_id }) {
  const history = useHistory();

  useEffect(() => {
    useMappingStore.getState().reset();
    useMappingUiStore.getState().reset();
    const mappingId = mapping_id === 'new' ? undefined : mapping_id;
    useMappingStore.getState().init(project_id, mappingId, {
      onProjectLoadError: () => history.push('/'),
    });
  }, [project_id, mapping_id]);
}
